<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Cierre de Caja</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button v-show="currentCierreId == ''" type="button" @click="consultar" class="btn-info"><i class="fa fa-search"></i>Consultar valores</button>
                    <button v-show="currentCierreId == '' && cierreConsultado" type="button" @click="cerrarCaja" class="btn-secondary"><i class="fa fa-check"></i><span>Cerrar caja</span></button>
                    <button v-show="currentCierreId !== ''" type="button" @click="exportar" class="btn-success"><i class="fa fa-file-excel-o"></i>Exportar</button>
                    <button @click="verListado" class="btn-primary" type="button">
                        <i class="fa fa-table"></i><span>Listado de cierres</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h3>Información de cierre</h3>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                    id="fecha"
                                    v-model="form.fecha"
                                    locale="es"
                                    no-label
                                    button-now-translation="Ahora"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    formatted="YYYY-MM-DD HH:mm:ss"
                                    label="Seleccione fecha..."
                                />
                                <label>Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="bodegas.length > 1" class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select @input="inputBodega" id="bodega_id" v-model="selectedBodega" :options="bodegas" label="descripcion"></v-select>
                                <label for="bodega">Sucursal</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <input-field readonly vMoney :format="money" placeholder="Ingrese un valor..." id="valor_inicial" v-model="form.valor_inicial">
                                Valor Inicial en Caja
                            </input-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Rubros</h5>
            </div>
            <div class="card__content">
                <div style="max-height: 300px" class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Colaborador</th>
                                <th>Recaudación</th>
                                <th>Viáticos</th>
                                <th>Peaje</th>
                                <th>Combustible</th>
                                <th>Alq/Veh.</th>
                                <th>Otros</th>
                                <th>Depósitos</th>
                                <th>Entrega</th>
                            </tr> 
                        </thead>
                        <tbody>
                            <tr v-for="(recaudador, index) in recaudadores" :key="index">
                                <td>
                                    {{ recaudador.nombre }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.recaudacion) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.almuerzo) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.peaje) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.gasolina) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.pago_carro) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.otros) }}
                                </td>
                                <td>
                                    {{ moneyFormat(recaudador.deposito) }}
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(calcularEntrega(recaudador)) }}</strong>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th scope="row">
                                    Totales
                                </th>
                                <td>
                                    <strong>{{ moneyFormat(totalRecaudacion) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalAlmuerzo) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalPeaje) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalGasolina) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalPagoCarro) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalOtros) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(totalDeposito) }}</strong>
                                </td>
                                <td>
                                    <strong>{{ moneyFormat(calcularEntregaTotal()) }}</strong>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <p>
                        <strong>Gastos en ruta: {{ moneyFormat(totalGastosRuta) }}</strong>
                    </p>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-xs-12 col-md-8">
                <div class="card">
                    <div class="card__title">
                        <h5>Gastos/Ingresos</h5>
                    </div>
                    <div class="card__content">
                        <div v-show="totalGastos == 0">
                            <p>
                                <strong>No se ha encontrado gastos.</strong>
                            </p>
                        </div>
                        <div style="max-height: 300px" v-for="(arrayGastos, index) in gastos" :key="index" class="table-responsive">
                            <h4>{{ index }}</h4>
                            <table>
                                <thead>
                                    <tr>
                                        <!-- <th>Tipo</th> -->
                                        <th>Fecha</th>
                                        <th>Detalle</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(gasto, key) in arrayGastos" :key="'gasto' + key + index">
                                        <!-- <td>
                                            {{ gasto.tipo === 'G'?'Gasto':'Ingreso' }}
                                        </td> -->
                                        <td>
                                            {{ gasto.fecha }}
                                        </td>
                                        <td>
                                            {{ gasto.detalle }}
                                        </td>
                                        <td>
                                            {{ moneyFormat(gasto.valor) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="card">
                    <div class="card__title">
                        <div class="table-responsive">
                            <table>
                                <tbody>
                                    <tr v-for="(ingreso, index) in ingresos" :key="index">
                                        <th scope="row">
                                            {{ ingreso.rubro }}
                                        </th>
                                        <td>
                                            {{ moneyFormat(ingreso.valor) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            Total de ingresos (+)
                                        </th>
                                        <td>
                                            <strong>{{ moneyFormat(totalIngresos) }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            Total gastos (-)
                                        </th>
                                        <td>
                                            <strong>{{ moneyFormat(totalGastos) }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            Total en caja
                                        </th>
                                        <td>
                                            <strong>{{ moneyFormat(total) }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        bodegas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    methods: {
        calcularEntregaTotal: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += this.calcularEntrega(this.recaudadores[i]);
            }
            return round(total, 2);
        },
        calcularEntrega: function (recaudacion) {
            let entrega = parseFloat(recaudacion.recaudacion)
                - (
                    parseFloat(recaudacion.almuerzo)
                    + parseFloat(recaudacion.peaje)
                    + parseFloat(recaudacion.gasolina)
                    + parseFloat(recaudacion.pago_carro)
                    + parseFloat(recaudacion.otros)
                    + parseFloat(recaudacion.deposito)
                );
            return round(entrega, 2); 
        },
        exportar: function () {
            window.open(url + '/cierre-caja/' + this.currentCierreId, '_blank');
        },
        inputBodega: function () {
            if (this.selectedBodega != null) {
                this.form.bodega_id = this.selectedBodega.id;
                this.form.valor_inicial = this.selectedBodega.valor_caja_inicial;
            }
            else 
                this.form.bodega_id = '';
        },
        cerrarCaja: function () {
            if (this.selectedBodega != null) {
                if (this.form.valor_inicial == '') {
                    swal('Debe ingresar un valor inicial de caja.', 'Aviso', 'warning');
                    return;
                }
                if (this.total < 0) {
                    swal('No se puede realizar un cierre de caja con valores negativos.', 'Aviso', 'warning');
                    return;
                }
                swal({
                    title: "¿Desea realizar el cierre de caja?",
                    text: "Se requiere confirmación",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if (result.value) {
                        axios.post(url + '/cierre-caja', this.form).then(({data}) => {
                            swal('La caja fue cerrada exitósamente.', 'Realizado', 'success');
                            this.currentCierreId = data.id;
                        }).catch(({response}) => {
                            if (response.status == 409) {
                                swal('La caja se encuentra cerrada, no se puede continuar.', 'Aviso', 'warning');
                            }
                            else if (response.status == 406) {
                                swal('Hay recaudaciones que no se han finalizado, no se permite cerrar.', 'Aviso', 'warning');
                            }
                            else 
                                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                        });
                    }
                });
            }
            else 
                swal('Debe seleccionar la sucursal del cierre.', 'Aviso', 'warning');
        },
        consultar: function () {
            if (this.selectedBodega != null) {
                axios.get(url + '/cierre-caja/consultar/informacion', {
                    params: this.form
                }).then(({data}) => {
                    this.recaudadores = data.recaudadores;
                    this.gastos = data.gastos;
                    this.cierreConsultado = true;
                    if (data.cierreCaja != null) {
                        this.currentCierreId = data.cierreCaja.id;
                        this.form.valor_inicial = data.cierreCaja.valor_inicial;
                        swal('La caja ya se encuentra cerrada en la sucursal seleccionada.', 'Aviso', 'warning');
                    }
                }).catch(() => {
                    swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                });
            }
            else 
                swal('Debe seleccionar una sucursal.', 'Aviso', 'warning');
        },
        verListado: function () {
            window.open(url + '/cierre-caja', '_blank');
        }
    },
    data: function () {
        return {
            form: {
                fecha: moment(new Date()).format('YYYY-MM-DD HH:mm'),
                bodega_id: '',
                valor_inicial: '',
                gastos_ruta: 0,
                depositos: 0,
                efectivo_deposito: 0,
                gastos_oficina: 0,
                recaudacion: 0
            },
            selectedBodega: null,
            recaudadores: [],
            gastos: [],
            moneyFormat: moneyFormat,
            currentCierreId: '',
            cierreConsultado: false,
            money: money
        };
    },
    mounted: function () {
        if (this.bodegas.length === 1) {
            this.selectedBodega = this.bodegas[0];
            this.inputBodega();
        }
    },
    computed: {
        totalGastosRuta: function () {
            let total = round(
                this.totalRecaudacion + this.totalAlmuerzo + this.totalPeaje 
                + this.totalGasolina + this.totalPagoCarro + this.totalOtros
            , 2);
            this.form.gastos_ruta = total;
            return total;
        },
        totalRecaudacion: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].recaudacion);
            }
            total = round(total, 2);
            this.form.recaudacion = total;
            return total;
        },
        totalAlmuerzo: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].almuerzo);
            }
            return round(total, 2);
        },
        totalPeaje: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].peaje);
            }
            return round(total, 2);
        },
        totalGasolina: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].gasolina);
            }
            return round(total, 2);
        },
        totalPagoCarro: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].pago_carro);
            }
            return round(total, 2);
        },
        totalOtros: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].otros);
            }
            return round(total, 2);
        },
        totalDeposito: function () {
            let total = 0;
            for (let i = 0; i < this.recaudadores.length; i++) {
                total += parseFloat(this.recaudadores[i].deposito);
            }
            total = round(total, 2);
            this.form.depositos = total;
            return total;
        },
        total: function () {
            let total = round(this.calcularEntregaTotal() + this.totalIngresos - this.totalGastos, 2);
            this.form.efectivo_deposito = total;
            return total;
        },
        totalIngresos: function () {
            let ingresos = 0;
            for (let key in this.gastos) {
                for (let i = 0; i < this.gastos[key].length; i++) {
                    if (this.gastos[key][i].tipo === 'I') {
                        ingresos += parseFloat(this.gastos[key][i].valor);
                    }
                }
            }
            return round(ingresos, 2);
        },
        totalGastos: function () {
            let gastos = 0;
            for (let key in this.gastos) {
                for (let i = 0; i < this.gastos[key].length; i++) {
                    if (this.gastos[key][i].tipo === 'G') {
                        gastos += parseFloat(this.gastos[key][i].valor);
                    }
                }
            }
            gastos = round(gastos, 2);
            this.form.gastos_oficina = gastos;
            return gastos;
        },
        ingresos: function () {
            let ingresos = [];
            for (let key in this.gastos) {
                let total = 0;
                for (let i = 0; i < this.gastos[key].length; i++) {
                    if (this.gastos[key][i].tipo === 'I') {
                        total += parseFloat(this.gastos[key][i].valor);
                    }
                }
                if (total > 0)
                    ingresos.push({
                        valor: total,
                        rubro: key
                    });
            }
            return ingresos;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/administrativo/CierreCaja.vue